<template>
    <div class="upload">
        <el-image class="elImg" @click.stop="handleClickItem" :z-index="99999" v-if="imageUrl" :src="imageUrl" :preview-src-list="srcList"></el-image>
        <el-avatar :size="110" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" class="avatar" v-else></el-avatar>
        <el-upload action="" :http-request="toUpload" :before-upload="beforeAvatarUpload" :show-file-list="false">
            <el-button size="small" type="primary" icon="el-icon-upload2" class="upBtn">{{imageUrl ? '更换头像' : '上传头像'}}</el-button>
            <!-- <span slot="tip" class="tip">只能上传jpg/png/jpeg格式，且不超过2MB <span class="remark">(尺寸为：{{size}})</span> </span> -->
        </el-upload>
        <!-- <el-upload list-type="picture-card" :http-request="toUpload" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
      </el-upload> -->
    </div>
</template>

<script>
import { uploadImg } from '@/api/system/operation'
export default {
    props: {
        imgUrls: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: ''
        }
    },
    components: {},
    computed: {},
    watch: {
        imgUrls(url) {
            //console.log(url);
            this.imageUrl = url;
            this.srcList = [url];
        }
    },
    data() {
        return {
            imageUrl: this.imgUrls,
            srcList: [this.imgUrls]
        }
    },
    created() { },
    methods: {
        handleClickItem() {
            // 获取遮罩层dom
            setTimeout(() => {
                let domImageMask = document.querySelector(".el-image-viewer__mask");
                if (!domImageMask) {
                    return;
                }
                domImageMask.addEventListener("click", () => {
                    // 点击遮罩层时调用关闭按钮的 click 事件
                    document.querySelector(".el-image-viewer__close").click();
                });
            })
        },
        // handlePictureCardPreview() {

        // },
        // handleRemove() {

        // },
        toUpload(file) {
            let _this = this;
            let [multipartFile] = [file.file];
            let fd = new FormData();
            fd.append('businessType', '1');
            fd.append('multipartFiles', multipartFile);
            fd.append('userId', '0');
            // uploadImg('system/uploadImg', fd
            uploadImg(fd).then(res => {
                // //console.log(res);
                if (res.code == 200) {
                    _this.imageUrl = res.data[0];
                    _this.srcList[0] = res.data[0];
                    _this.$emit('getImgUrl', res.data[0]);
                } else {

                }
            })
            // .catch(res => {
            //     
            // })
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isName = file.name.length > 3;
            if (!isJPG) {
                this.$message.error('图片只能上传 PNG、JPG、JPEG 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 2MB!');
                return false;
            }
            // return true;
            return isJPG && isLt2M; // && isName
        }
    },
}
</script>

<style scoped lang="less">
.upBtn {
    display: block;
    margin-bottom: 10px;
    //   height: 20px;
}
.elImg {
    width: 100px;
    height: 100px;
    border-radius: 50%;
}
.upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 30rpx;
    .elImg,
    .avatar {
        margin-bottom: 20px;
    }
}
.upload > div,
.upload /deep/ .el-form-item--small .el-form-item__label,
.upload /deep/ .el-upload,
.upload /deep/ .el-form-item__content {
    line-height: normal !important;
}
.upload /deep/ .el-image-viewer__btn {
    background: #fff;
    color: #000 !important;
}
.upload /deep/ .el-table {
    color: #000;
}
.tip {
    font-size: 14px;
    margin-left: 10px;
    color: grey;
}
/deep/ .el-image-viewer__btn {
    color: #000 !important;
}
.remark {
    color: red;
}
</style>
